// Modified from https://github.com/palmerhq/radio-group
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FocusEvent, createContext } from 'react';

type RadioGroupCtx<V, Siblings = V[]> = {
  groupId: string;
  otherRadioValues: Siblings;
  setChecked: (value: V) => void;
  value: V;
};

const RadioGroupContext = createContext<RadioGroupCtx<any>>({} as any);

type RadioProps<V> = {
  onBlur?: (e: FocusEvent) => void;
  onFocus?: (e: FocusEvent) => void;
  value?: V;
};

type RadioGroupProps<V> = {
  children: React.ReactElement<RadioProps<V>>[];
  labelledBy: string;
  onChange: (value: V) => void;
  value?: V;
};

export { RadioGroupContext, RadioGroupCtx, RadioGroupProps, RadioProps };
